import React from "react";

const Section1About = () => (
  <>
    <h2>1. About Us</h2>
    <p>
      At Comparedly, we’re not just building a platform — we’re creating a smarter way for businesses, creators, and agencies to understand their social media performance. In an increasingly crowded digital world, we believe in clarity, transparency, and actionable insights that truly make a difference.
      </p>
      <p>
      Founded with a simple yet powerful vision — to eliminate guesswork from social media analytics — Comparedly was born out of a deep frustration with traditional reporting tools that are either too simplistic or painfully complex. We saw an opportunity to bring a refreshing change. So, we set out to build a solution that bridges the gap between raw data and real impact.
      </p>
      <p>
      Our platform is designed to empower users of all technical backgrounds — whether you're a data-savvy marketer, a solo content creator, or part of a fast-growing brand. We give you the confidence to make informed decisions backed by unified, intelligent, and context-rich analytics.
      </p>
  </>
);

export default Section1About;
